import { Area } from "Models/Areas/Area";
import { Action } from "redux";

export const enum ActionTypes {
    AREAS_RETRIEVED = "AREAS_RETRIEVED",
}

export interface IAreasRetrievedAction extends Action {
    type: ActionTypes.AREAS_RETRIEVED;
    data: Area[];
}

export type AreaActions = IAreasRetrievedAction;


// WEBPACK FOOTER //
// ./src/Store/Areas/AreaActionTypes.ts